<template>
  <div>
    <chart :options="option"></chart>
  </div>
</template>
<script>
export default {
  data() {
    return {
      option: {
        title: {
          text: '平台文章发布情况',
          textStyle: {
            color: '#008B8B'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['新闻', '会务', '政策']
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '新闻',
            type: 'line',
            stack: '总量',
            areaStyle: {},
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '会务',
            type: 'line',
            stack: '总量',
            areaStyle: {
              color: '#D2C8E6'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          },
          {
            name: '政策',
            type: 'line',
            stack: '总量',
            areaStyle: {
              color: '#A5D1F0'
            },
            data: [150, 232, 201, 154, 190, 330, 410]
          }
        ]
      }
    };
  },
  props: {
    color: String,
    data: Array,
    size: { type: String, default: 'default' }
  }
};
</script>
<style lang="stylus" scoped>
.echarts {
  width 100%
}
</style>



// WEBPACK FOOTER //
// src/common/component/stackingChart.vue